<div class="card">
    <div class="card-header">
        <h2 class="card-title">Recent Activity</h2>
    </div>
    <div class="card-body">
        <ul class="list-group list-group-flush user-recents-list">
            @for (recent of recents; track recent.id) {
                <li class="list-group-item" [routerLink]="['/' + recent.resource, recent.i]">
                    <span class="md-24" [class.material-icons]="!['collections', 'reports'].includes(recent.resource)" [class.material-icons-outlined]="['collections', 'reports'].includes(recent.resource)">{{icon(recent.resource)}}</span>
                    <div class="text-truncate">
                        <h5>{{recent.label}}</h5>
                        <p class="subtitle">{{recent.resource}}</p>
                    </div>
                    <p>{{when(recent.accessed)}}</p>
                </li>
            }
            @empty {
                <li class="list-group-item">No recent items accessed by this user yet.</li>
            }
        </ul>
    </div>
</div>